// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"ee6b8ab5","453":"af178710","614":"5e06bd8a","842":"905ec0b6"}[chunkId] + ".chunk.js";
};